import { useMutation, useQueryClient } from 'react-query';
import request from '../../../helpers/request';
import { createInfoAttachmentListKey } from '../queries/useInfoAttachmentList';

const deleteAttachment = async ({ infoId, attachId }) => {
  const data = await request.delete(
    `/Information/attachment`,
    { infoId, attachId },
    'Не удалось удалить вложение',
    'Error'
  );

  return data;
};

const useDeleteAttachment = () => {
  const queryClient = useQueryClient();

  const deleteAttachMutation = useMutation(
    (params) => deleteAttachment(params),
    {
      onSuccess: (data, params) => {
        if (data !== 'Error') {
          queryClient.setQueryData(
            createInfoAttachmentListKey(params.infoId),
            (oldData) =>
              oldData.filter((oldAttach) => oldAttach.id !== params.attachId)
          );
        }
      },
    }
  );

  const deleteMutateAsync = (params) =>
    deleteAttachMutation.mutateAsync(params);

  return {
    deleteAttachmentAsync: deleteMutateAsync,
  };
};

export default useDeleteAttachment;
